import { useEffect } from 'react';

export default function StadiumDronePlannerPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Stadium Drone Survey | Cr3ate';
    return () => { document.title = previousTitle; };
  }, []);

  return (
    <iframe
      src="/tools/stadium-drone-planner/index.html"
      title="Stadium drone seat survey planner"
      className="fixed inset-0 h-full w-full border-0"
      allow="fullscreen"
    />
  );
}
